module.exports = __webpack_public_path__ + "static/media/icon-button-add-white.3f39fa74.svg";